import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { userService } from '@/services/api/userService'
import { useAuthStore } from '@/stores/auth-store'

export function useLanguagePreferences() {
  const { i18n } = useTranslation()
  const { user } = useAuthStore()
  const [isSaving, setIsSaving] = useState(false)

  const saveLanguagePreference = async (language: string) => {
    if (!user?.sub) return

    setIsSaving(true)
    try {
      await userService.updateUserProfile(user.sub, {
        preferences: {
          lang: language
        }
      })
    } catch (error) {
      console.error('Failed to save language preference:', error)
    } finally {
      setIsSaving(false)
    }
  }

  const changeLanguage = async (lng: string) => {
    // Change the language immediately for better UX
    i18n.changeLanguage(lng)
    
    // Save the preference to the backend
    await saveLanguagePreference(lng)
  }

  return {
    currentLanguage: i18n.language,
    changeLanguage,
    isSaving
  }
}
